import axios from 'axios';

const api = axios.create({
  withCredentials: false,
  headers: { accept: 'application/json' },
});

export default api;
